import { render, staticRenderFns } from "./ImageCaption.vue?vue&type=template&id=9e20ee8c&scoped=true&lang=html&"
import script from "./ImageCaption.vue?vue&type=script&lang=js&"
export * from "./ImageCaption.vue?vue&type=script&lang=js&"
import style0 from "./ImageCaption.vue?vue&type=style&index=0&id=9e20ee8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e20ee8c",
  null
  
)

export default component.exports